import { mapState, mapGetters, mapActions } from 'vuex'

export const Computed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
    currentUserId: (state) => state.currentUserId,
    currentUserToken: (state) => state.currentUserToken,
  }),
  ...mapGetters('auth', ['loggedInUser', 'loggedInToken']),
}

export const Methods = mapActions('auth', ['logIn', 'logOut', 'updatePassword'])
